import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getJiraSummarySlice } from './get';

export const jiraSummaryReducers = combineReducers({
	get: getJiraSummarySlice.asyncReducers
});

export const jiraSummaryWatchers = combineAllWatchers([
	getJiraSummarySlice.asyncWatchers
]);
